import { handleResponse,handleError } from '../apiUtil';
import http from '../http-common';

export const getAllProducts = () => http.get('product/all').then(handleResponse).catch(handleError);
export const get = (id) => http.get(`product/${id}`).then(handleResponse).catch(handleError);
export const create = (data) =>http.post('product/create/', data).then(handleResponse).catch(handleError);
export const update = (id, data) => http.put(`product/update/${id}`, data).then(handleResponse).catch(handleError);
export const remove = (id) => http.delete(`product/delete/${id}`).then(handleResponse).catch(handleError);
export const updateUsingId = (id,data)=> http.put(`product/update/${id}`, data).then(handleResponse).catch(handleError);
export const getByQuantity = (qty)=> http.get(`product/search/by_quantity/${qty}`).then(handleResponse).catch(handleError);
export const getByName = (name) => http.get(`product/search/${name}`).then(handleResponse).catch(handleError);
